import Axios from 'axios';
import { appConfig } from 'config/appConfig';

export const createBaseAxios = () =>
  Axios.create({
    baseURL: appConfig.apiUrl,
    headers: {
      Authorization: `Basic ${appConfig.bearerToken}`,
    },
  });

export const createJWTAuthorizedAxios = (token: string) =>
  Axios.create({
    baseURL: appConfig.apiUrl,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
